import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../../constants';
import { NotificationService } from '../../../services/notification.service';
import { ThreadService } from '../../../services/api/thread.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'strategy-details-modal',
  templateUrl: './details-modal.component.html',
  styleUrls: ['./details-modal.component.scss']
})
export class DetailsModalComponent implements OnInit {

  admin: any;
  edit: any = false;
  strategy: any = {}
  strategyParams: any = {}

  bas = [CONSTANTS.DEFAULT.BROKER];
  strategies = [CONSTANTS.DEFAULT.STRATEGY];

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.onStrategyDetailsOpening.subscribe(data => {
      this.strategy = data.strategy;
      this.edit = data.edit;
      this.populateDatas(data);
      this.populateStrategyModalParams();
      this.dataService.strategyDetailsPopulating({edit: this.edit, strategy: this.strategy,
        strategyParams: this.strategyParams, symbols: data.symbols});
    });
    this.dataService.onStrategyDetailsSaved.subscribe(data => {
      if (data.success) {
        this.resetDefaults();
      }
    });
  }

  resetDefaults() {
    this.strategy = {};
    this.edit = false;
    this.strategyParams = {};
  }

  populateDatas(data: any) {
    this.strategies = this.dataService.getStrategies();
    this.bas = data.bas;
  }

  populateStrategyModalParams() {
    let original = this.strategy["original"]
    this.strategyParams = { original, update: this.edit };
    this.strategyParams['header'] = `${this.edit ? "Edit" : "Add"} - ${original["strategy"]["display_name"]}`;
    this.strategyParams['show_status'] = this.edit;
    this.strategyParams['code'] = original["strategy"]["name"].toLowerCase();
    this.strategyParams['enabled'] = (original["status"] == 'enabled');
    this.strategyParams['strategy_name'] = original["strategy"]["name"];
    this.strategyParams['ba_name'] = `${original['ba']['name']}/${original['ba']['client_id']}`;
  }

  getUserBrokerByName(name: any) {
    for (let i = 0; i < this.bas.length; i++) {
      if (this.bas[i].name == name) {
        return this.bas[i];
      }
    }
    return CONSTANTS.DEFAULT.BROKER;
  }

  getStrategyByName(name: any) {
    for (let i = 0; i < this.strategies.length; i++) {
      if (this.strategies[i].name == name) {
        return this.strategies[i]
      }
    }
    return CONSTANTS.DEFAULT.STRATEGY;
  }

  saveEditSettingsPopup(event: any, params: any) {
    let config = params.original;
    let data: any = {
      ba: this.getUserBrokerByName(params.ba_name)._id,
      strategy: this.getStrategyByName(params.strategy_name)._id,
      script: config.script,
      script_details: config.script_details,
    }
    if (params.update) {
      data['tid'] = config._id;
    } else {
      if (this.admin == 'true') {
        data['user'] = config.user.user_id;
      }
    }
    this.dataService.saveSettings({ code: this.strategyParams.code, params: params, data: data});
  }

  cancelEditSettingsPopup(params: any) {
    this.dataService.strategyDetailsSaved({ success: true });
  }

  onStrategySelected() {
    this.dataService.strategyChanging({strategy_name: this.strategyParams.strategy_name, edit: this.edit });
  }

  closeModal(params: any) {
    this.dataService.strategyDetailsSaved({ success: true });
  }
}
